import SubComponentSku from '../../../../components/Main/Product/Lines/SubComponentSKU'
import CustomSpin from '../../../../elements/CustomSpin'
import FormGenerator from '../../../../elements/FormGenerator'
import FormSectionTitle from '../../../../elements/FormSectionTitle'
import CurrencySelect from '../../../../elements/Select/Currency'
import UOM from '../../../../elements/Select/UOM'
import ShippingDetails from '../../../../elements/ShippingDetails'
import withFormItemView from 'form-item-view-hoc'
import React, { useEffect } from 'react'
import { Checkbox, Col, Form, Input, InputNumber, Row } from 'antd'
import { get, isEmpty, round } from 'lodash'

import { defaultFormItemLayout, fullWidthFormItemLayout, rules } from '../../../../modules/FormItems'
import useFetchObject from '../../../../elements/Hooks/useFetchObject'
import Corporate from '../../../../api/Corporate'
import { numVal, strVal } from '../../../../modules/Utils'
import TaxTypeSelect from '../../../../elements/Select/Lines/TaxType'
import { compose } from 'recompose'

const CustomFormItem = compose(withFormItemView)(Form.Item)

const { TextArea } = Input

const corporateApi = new Corporate()

function ProductLinesForm (props) {
  const { line, product, formGen, fetchingForm } = props
  const { getFieldDecorator, getFieldValue, setFieldsValue, resetFields } = props.form
  const companyKey = strVal(product, 'company._id').replace('members/', '')
  const { object: corporate, fetching, fetch } = useFetchObject(
    () => corporateApi.getByOwner(companyKey),
    false,
    [companyKey],
    isEmpty(companyKey),
  )
  const productType = get(product, 'type')
  const isService = get(product, 'isService') !== false
  const taxRate = get(corporate, 'tax.percentage')

  const productName = get(product, 'name')
  const uom = getFieldValue('uom.code')
  const currency = getFieldValue('currency')
  const taxType = getFieldValue('tax.type')

  useEffect(() => {
    if (!isEmpty(productName) && !isEmpty(uom) && !isEmpty(currency) && !isEmpty(taxType)) {
      const name = `${productName} (${uom}) - ${currency} [TAX ${taxType}]`
      setFieldsValue({ name })
    }
  }, [productName, uom, currency, taxType])

  return (
    <CustomSpin spinning={fetchingForm}>
      <Form>
        <Row>
          <Col span={24}>
            <CustomFormItem readOnly={true} {...fullWidthFormItemLayout} label="Name">
              {getFieldDecorator('name', {
                initialValue: `${get(line, 'name')}`,
                rules: rules.input,
              })(<Input disabled={true} placeholder={'Name'}/>)}
            </CustomFormItem>
          </Col>
        </Row>
        {/*<Row>
          <Col span={24}>
            <Form.Item {...fullWidthFormItemLayout} label="Specifications">
              {getFieldDecorator('cost.description', {
                initialValue: get(line, 'description'),
              })(<TextArea rows={7}/>)}
            </Form.Item>
          </Col>
        </Row>*/}
        {/*<Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Tax Type'}>
              {getFieldDecorator('tax.type', {
                initialValue: get(line, 'tax.type'),
                rules: [
                  {
                    required: true,
                    message: 'Please Select a Tax Type!',
                  },
                ],
              })(<TaxTypeSelect style={{ width: '100%' }}/>)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Override  Tax %">
              {getFieldDecorator('overrideCompanyPercentage', {
                initialValue: get(line, 'overrideCompanyPercentage'),
                valuePropName: 'checked',
              })(<Checkbox/>)}
            </Form.Item>
          </Col>
        </Row>*/}
        {/*<Row>
          {getFieldValue('overrideCompanyPercentage') && (
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label="Tax Percentage">
                {getFieldDecorator('tax.percentage', {
                  initialValue: get(line, 'tax.percentage'),
                })(
                  <InputNumber
                    precision={3}
                    formatter={value => `${value}%`}
                    parser={value => value.replace('%', '')}
                    style={{ width: '100%' }}
                    placeholder={'Tax percentage per uint between 0 to 100'}
                    min={0}
                    max={100}
                  />,
                )}
              </Form.Item>
            </Col>
          )}
        </Row>*/}
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="UOM">
              {getFieldDecorator('uom.code', {
                initialValue: get(line, 'uom.code'),
                rules: rules.select,
              })(<UOM disabled/>)}
            </Form.Item>
          </Col>
          {/*<Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Units / SKU">
              {getFieldDecorator('cost.skuUnits', {
                initialValue: get(line, 'cost.skuUnits'),
                //rules: rules.select,
              })(
                <Input type="number" style={{ width: '100%' }} placeholder={'Units per SKU'}/>,
              )}
            </Form.Item>
          </Col>*/}
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Buy Currency">
              {getFieldDecorator('cost.currency', {
                initialValue: get(line, 'cost.currency'),
                rules: rules.input,
              })(<CurrencySelect style={{ width: '100%' }}/>)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Buy Price">
              {getFieldDecorator('cost.rate', {
                initialValue: get(line, 'cost.rate'),
              })(
                <Input
                  type="number"
                  /*onBlur={e => {
                    if (taxRate > 0) {
                      const value = numVal(e, 'target.value')
                      const rate = round(value * taxRate, 3)
                      setFieldsValue({
                        'tax.rate': rate,
                      })
                    }
                  }}*/
                  addonAfter={<strong>{get(line, 'cost.currency')}</strong>}
                  style={{ width: '100%' }}
                  placeholder={'Price per unit'}
                />,
              )}
            </Form.Item>
          </Col>
          {/*{taxRate !== undefined && (
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label="Company Tax ">
                <strong>{taxRate} %</strong>
              </Form.Item>
            </Col>
          )}*/}
        </Row>
       {/* {!isService && (
          <>
            <Row>
              <FormGenerator
                {...{
                  formGen,
                  form: props.form,
                  data: line,
                }}
              />
            </Row>
            <Row>
              <FormSectionTitle title="Sub Component"/>
              <SubComponentSku {...{ product, data: line, form: props.form }} />
            </Row>

            <Row>
              <ShippingDetails
                line={get(line, 'shipping')}
                {...{
                  getFieldDecorator,
                  getFieldValue,
                  setFieldsValue,
                  resetFields,
                  type: 'product',
                }}
              />
            </Row>
          </>
        )}*/}
      </Form>
    </CustomSpin>
  )
}

ProductLinesForm.propTypes = {}
ProductLinesForm.defaultProps = {}

export default Form.create()((ProductLinesForm))
